/**
 * EstrategiaNutricional — static summary card for the weekly nutrition strategy.
 *
 * Displays the section heading and subtitle per the reference site design.
 * No dynamic data — purely structural/presentational.
 * No dangerouslySetInnerHTML. No native dialogs.
 */

// ---------------------------------------------------------------------------
// EstrategiaNutricional
// ---------------------------------------------------------------------------

export function EstrategiaNutricional(): JSX.Element {
  return (
    <section aria-label="Estrategia nutricional">
      <div className="mb-3">
        <h2 className="text-lg font-bold text-zinc-100">Estrategia Nutricional</h2>
        <p className="text-sm text-zinc-500">
          Plan semanal personalizado basado en tu entrenamiento
        </p>
      </div>
    </section>
  );
}
